const initialState = {
    changePasswordStatus:false,
    forgotPasswordStatus:false,
    forgotPasswordDetails:null,
    loginDetails: null,
    refresh_token:null,
    loginStatus:false,
    profileDetails:null,
    profileStatus : false,
    editProfileDetails:null,
    editProfileStatus:false,
    newPassStatus: false,
    newPassDetails:null,
    randomPassStatus: false,
    randomPassDetails:null,
    getNpiData:null,
    getNpiStatus:false,
    emailValidStatus:false,
    mobileValidStatus:false,
    message: null,
    error:null,
    warning:null,
    isLoading: false,
    contactStatus:false,
    saveRegDataStatus:false,
    viewRequestInfoDetails:null,
    viewRequestInfoStatus: false,
    verifyRegisterStatus: false,
    sessionExpireStatus: false

  };
  export default initialState;